YP.TypeProduct = function() {
    return {
        init: function(){
            function handleTypeProductQuantity(input) {
                var val           = input.val(),
                    typeProductId = input.data('id'),
                    sum           = 0,
                    max           = Math.abs($(".max-container .max[data-id=" + typeProductId + "]").data('max')),
                    currentMax    = input.attr('max'),
                    left          = 0;

                $(".ypl-store_product_price_input[max][data-id=" + typeProductId + "]").each(function(){
                    sum += Math.abs($(this).val());
                });

                left = max - sum;
                $(".ypl-store_product_price_input[max][data-id=" + typeProductId + "]").each(function(){
                    currentVal = Math.abs($(this).val());
                    if((currentVal + left) <= max) {
                        $(this).attr('max', left + currentVal);
                    } else {
                        $(this).attr('max', left);
                    }
                });

                if(left <= max && left >=0) {
                    $(".max-container .max[data-id=" + typeProductId + "]").text(left);
                }
            };

            $(".ypl-store_product_price_quantity_add").live("click", function(e) {
                number = $(this).data('number');
                var input = $(".ypl-store_product_price_input[data-number=" + number + "]");

                if (!input.attr("max") || Math.abs(input.attr("max")) > Math.abs(input.val())) {
                    input.val(Math.abs(input.val()) + 1);
                    handleTypeProductQuantity(input);
                }
            });

            $(".ypl-store_product_price_quantity_remove").live("click", function(e) {
                number = $(this).data('number');
                var input = $(".ypl-store_product_price_input[data-number=" + number + "]");
                if (Math.abs(input.val()) > 0) {
                    input.val(Math.abs(input.val()) - 1);
                    handleTypeProductQuantity(input);
                }
            });

            function wrapWorkshopSessionPrices($scope) {
                $scope.find(".c-form-field__checkbox label").each(function () {
                    var $label = $(this);
                    if ($label.find(".js-workshop-session-price").length) {
                        return;
                    }
                    var match = $label.text().match(/^(.*) - ([\d\s]+,\d{2}\s€)$/);
                    if (match) {
                        $label.html(
                            match[1] + ' - <span class="js-workshop-session-price">' + match[2] + '</span>'
                        );
                    }
                });
            }

            function toggleWorkshopSessionInvite($scope, isInvite) {
                $scope.find(".js-workshop-session-price").each(function () {
                    var $price = $(this);
                    if (isInvite) {
                        if (!$price.data('original')) {
                            $price.data('original', $price.text());
                        }
                        $price.css({ "text-decoration": "line-through", opacity: 0.6 });
                        if (!$price.next(".js-workshop-session-price-override").length) {
                            $("<span>", { class: "js-workshop-session-price-override" })
                                .css({ "font-weight": "bold" })
                                .text(" 0 €")
                                .insertAfter($price);
                        }
                    } else {
                        $price.css({ "text-decoration": "", opacity: "" });
                        $price.next(".js-workshop-session-price-override").remove();
                    }
                });
            }

            function applyAddType($scope) {
                var isInvite = $scope.find(".js-add-type-group input[type=radio]:checked").val() === "INVITATION";
                $scope.find(".js-payment-method-item").toggle(!isInvite);
                wrapWorkshopSessionPrices($scope);
                toggleWorkshopSessionInvite($scope, isInvite);
            }

            $(".js-add-type-group input[type=radio]").live("change", function () {
                applyAddType($(this).closest(".c-form, .ypl-store_product"));
            });

            $(".js-add-type-group").each(function () {
                applyAddType($(this).closest(".c-form, .ypl-store_product"));
            });
        }
    };
};
